import type { IdeaDto, PublicationKind, RenderExampleDto } from '@app/shared';

/** The format a card advises (spec 3): the brain's one while the passport offers it, else «Сцены». */
export function adviceKind(idea: IdeaDto, kinds: readonly PublicationKind[]): PublicationKind {
  return kinds.includes(idea.kind) ? idea.kind : 'reel_scenes';
}

/** The kind the card names: the one it was taken as, else the advised one. */
export function shownKind(idea: IdeaDto, advised: PublicationKind): PublicationKind {
  return idea.draftId !== null ? (idea.takenKind ?? idea.kind) : advised;
}

/**
 * The examples worth fetching while the person reads the ideas (the speed-up): the
 * picture and the demo of the formats the not-taken cards advise, the first `max`
 * distinct ones — «Взять» then opens «Формат и текст» with its example in the cache.
 */
export function examplesToWarm(
  ideas: readonly IdeaDto[],
  kinds: readonly PublicationKind[],
  examples: readonly RenderExampleDto[],
  max = 2,
): string[] {
  const advised: PublicationKind[] = [];
  for (const idea of ideas) {
    if (idea.draftId !== null) continue;
    const kind = adviceKind(idea, kinds);
    if (!advised.includes(kind)) advised.push(kind);
    if (advised.length === max) break;
  }
  return advised.flatMap((kind) => {
    const e = examples.find((x) => x.kind === kind);
    return e ? [e.imageUrl, e.videoUrl].filter((u): u is string => u !== null) : [];
  });
}
